export enum ModeOfTransport {
  Private = 'Private',
  Bike = 'Bike',
  PublicTransport = 'Public transport',
}
